module.exports = __webpack_public_path__ + "static/016.thumb-185a8dd49885a9b4e01599370737b6a8.jpg";